/**
 * @description 组织架构 相关接口 http://api.umucdn.cn/project/266/interface/api/cat_169
 * @author liushuai
 */

import { API_TYPE } from '@umu/umu-fetch';
const BasePath = '/uapi/v1/department';
const BaseDashboardPath = '/uapi/v1/dashboard';

export const DepartmentAPI = {
    /**
     * 获取部门列表
     */
    GET_DEPARTMENT_LIST: {
        url: `${BasePath}/get-childdepartments-byid`,
        type: API_TYPE.GET,
    },

    /**
     * 获取部门搜索
     */
    GET_DEPARTMENT_SUG: {
        url: `${BasePath}/sug`,
        type: API_TYPE.GET,
    },

    /**
     * 获取成员搜索
     */
    GET_MEMBER_SUG: {
        url: `${BasePath}/sug-member`,
        type: API_TYPE.GET,
    },

    /**
     * 获取部门详情
     */
    GET_SUB_DEPARTMENT_LIST: {
        url: `${BasePath}/get-by-departmentid`,
        type: API_TYPE.GET,
    },

    /**
     * 分页获取部门下的成员
     */
    GET_MEMBER_LIST: {
        url: `${BasePath}/member-list`,
        type: API_TYPE.GET,
    },

    /**
     * 添加单个部门
     */
    ADD_DEPARTMENT: {
        url: `${BasePath}/add`,
        type: API_TYPE.POST,
    },

    /**
     * 编辑单个部门
     */
    EDIT_DEPARTMENT: {
        url: `${BasePath}/edit`,
        type: API_TYPE.POST,
    },

    /**
     * 删除部门
     */
    DELTE_DEPARTMENT: {
        url: `${BasePath}/delete`,
        type: API_TYPE.GET,
    },

    /**
     * 部门排序
     */
    SORT_DEPARTMENT: {
        url: `${BasePath}/sort`,
        type: API_TYPE.POST,
    },

    /**
     * 成员调整部门
     */
    CHANGE_MEMBER_DEPARTMENT: {
        url: `${BasePath}/change-member-department`,
        type: API_TYPE.POST,
    },

    /**
     * 批量删除部门成员
     */
    BATCH_DELETE_MEMBER: {
        url: `${BasePath}/batch-delete-member`,
        type: API_TYPE.GET,
    },

    /**
     * 获取当前登陆用户所在的部门即角色信息
     */
    GET_DEPARTMENTS_BY_UMUID: {
        url: `${BasePath}/get-departments-by-umuid`,
        type: API_TYPE.GET,
    },
    GET_DEPARTMENTS_BY_MANAGERID: {
        url: `${BasePath}/get-departments-by-managerid`,
        type: API_TYPE.GET,
    },
    GET_ALL_BYLEVEL: {
        url: `${BasePath}/get-all-bylevel`,
        type: API_TYPE.GET,
    },

    /**
     * 分页获取不在某个部门id下的企业用户
     */
    GET_USERS_NOT_IN_DEPARTMENT: {
        url: `${BasePath}/users-not-in-department`,
        type: API_TYPE.GET,
    },

    /**
     * 模糊搜索不咋起该部门id的企业用户
     */
    SEARCH_USER_OUT_DEPARTMENT: {
        url: `${BasePath}/search-user-out-department`,
        type: API_TYPE.GET,
    },
    GET_DEPARTMENT_SLIDER_COURSE_LIST: {
        url: `${BaseDashboardPath}/departmentboard-hot-group-list`,
        type: API_TYPE.GET,
    },
    GET_DEPARTMENT_STUDY_REPORT_LIST: {
        url: `${BaseDashboardPath}/departmentboard-study-report`,
        type: API_TYPE.GET,
    },
    GET_DEPARTMENT_SESSION_REPORT_LIST: {
        url: `${BaseDashboardPath}/get-sessions-by-type`,
        type: API_TYPE.GET,
    },

    GET_DEPARTMENT_MEMBERS: {
        url: `/uapi/v1/department/member-list`, // 获取部门成员
        type: API_TYPE.GET,
    },
};
